<template>
  <div class="input-date-picker">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          class="input-date-picker__form"
          :class="{
            'input-date-picker__form-disabled': disabled,
          }"
          :rules="rules"
          :value="dateFormatted"
          outlined
          @change="dateTyped"
          :disabled="disabled"
          v-on="on"
        >
          <template v-slot:append>
            <v-icon
              :disabled="disabled"
              class="input-date-picker__icon"
              v-on="on"
              >mdi-calendar-blank</v-icon
            >
          </template>
        </v-text-field>
      </template>
      <v-date-picker v-model="date" no-title scrollable locale="ru-ru">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">Отмена</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "InputDatePicker",
  model: {
    props: "value",
    event: "change",
  },
  props: ["value", "disabled", "min", "max", "rules"],
  data: () => ({
    date: null,
    dateFormatted: null,
    menu: false,
  }),
  watch: {
    date(val) {
      if (val) {

        let resultdate = new Date(val);
        if (
          (!this.min || this.min <= resultdate.getTime()) &&
          (!this.max || this.max >= resultdate.getTime())
        ) {
          this.$refs.menu.save(val);
          this.dateFormatted = val ? this.formatDate(val) : "";
          this.$emit("change", val);
        }
      } else {
        this.dateFormatted = null;
      }
    },
    value: {
      immediate: true,
      handler: function (val) {
        this.date = val ? new Date(val).toISOString().substr(0, 10) : null;
      },
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;
      const [y, m, d] = date.split("-");
      const displayDate = new Date(y, m - 1, d).toLocaleString("default", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return displayDate;
    },

    dateTyped(date2) {
      if (!date2) {
        return null;
      }
    
      var dateParser = /(\d{1,2})[./](\d{1,2})[./](\d{4})/;
      var match = date2.match(dateParser);

      if (match !== null) {
        var date = new Date(
          match[3], // year
          match[2] - 1, // monthIndex
          match[1], // day
          3
        )
          .toISOString()
          .substr(0, 10);

        if (date) {
          if (
            (!this.min || this.min <= date.getTime()) &&
            (!this.max || this.max >= date.getTime())
          ) {
            this.dateFormatted = date ? this.formatDate(date) : "";
            this.$emit("change", date);
          }
        }
      } else {

        var date = new Date().toISOString().substr(0, 10);
        
        if(this.date === null)
        {
            this.date = date;
        }
        else
        {
            this.date = null;
        }
          this.dateFormatted = date ? this.formatDate(date) : "";
          this.$emit("change", date);
      }
    },
  },
};
</script>

<style lang="scss">
.input-date-picker {
  &__form:hover &__icon:not([disabled]) {
    color: $main-orange;
  }

  .input-date-picker__form.input-date-picker__form-disabled fieldset {
    border-color: rgba(0, 0, 0, 0.24) !important;
  }
}
</style>
